export const primaryColor = "#879981";
export const primaryAccentColor = "#4a4a4a"; // also used for text should refactor
export const primaryHeaderColor = "#ad7361";
export const secondaryColor = "#9b7a81";
export const primaryTextColor = "#18216d";
export const primaryBackgroundColor = "rgb(241, 242, 243)";
export const buttonShadow = "rgb(23 31 114 / 20%)";
export const buttonBorder = "#edf3f5";
export const darkestColor = "#000";
export const lightestColor = "#fff";
